<template>
    <div v-in-viewport="fetchData">
        <graph-title
            :description="$t('analytics.insights.recruitment_process.interviews_statuses.description').toString()"
            :title="$t('analytics.insights.recruitment_process.interviews_statuses.title').toString()"
            icon="pie-chart"
        />
        <div class="w-full">
            <div v-if="fetching" class="h-336 w-full flex items-center justify-center">
                <loading color="blue" size="small"/>
            </div>
            <div v-else>
                <div v-if="!!seriesDataLength" class="h-240">
                    <div class="h-full relative">
                        <apexchart
                            id="interviewStatuses"
                            ref="interviewStatuses"
                            :options="chartOptions"
                            :series="series"
                            height="100%"
                            width="100%"
                        />
                    </div>
                </div>
                <div v-else class="flex flex-col px-10">
                    <span class="text-center italic my-16"></span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as analytics from "../../services/AnalyticsService";
import analyticsMixins from "../../mixins/analyticsMixins";
import GraphTitle from "./GraphTitle.vue";
import VueApexCharts from 'vue-apexcharts';
import chartOptions from '../../config/apex-charts';
import Loading from "../ui/Loading.vue";

export default {
    name: "InterviewsStatuses",
    components: {
        Loading,
        GraphTitle,
        'apexchart': VueApexCharts,
    },
    mixins: [analyticsMixins],
    props: {
        filterFields: {type: Object},
    },
    computed: {
        chartOptions() {
            return {
                ...chartOptions,
                chart: {
                    ...chartOptions.chart,
                    type: 'pie',
                    toolbar: {
                        ...chartOptions.chart.toolbar,
                        show: true,
                    }
                },
                colors: ['#008FFB', '#00E396', '#FF4560'],
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['white']
                },
                labels: [
                    this.$t('analytics.insights.recruitment_process.interviews_statuses.unconfirmed').toString(),
                    this.$t('analytics.insights.recruitment_process.interviews_statuses.confirmed').toString(),
                    this.$t('analytics.insights.recruitment_process.interviews_statuses.cancelled').toString(),
                ],
                legend: {
                    ...chartOptions.legend,
                    position: 'right',
                    markers: {
                        ...chartOptions.legend.markers,
                        offsetX: -2,
                    }
                }
            }
        },
        seriesDataLength() {
            return this.series.length;
        }
    },
    methods: {
        async fetchData(fresh = true) {
            if (!this.sendRequest() && !fresh) {
                this.fetching = false;
                return;
            }
            return await analytics.interviewsStatus(this.filterFields).then(response => {
                this.graphData = response;
            }).then(() => this.buildChart())
        },
        buildChart() {
            this.series = JSON.parse(JSON.stringify(this.graphData.data));
            this.fetching = false;
            this.$nextTick(() => {
                this.graphRef = this.$refs.interviewStatuses;
                this.setDownloadButtonId(this.graphRef, 'downloadChartInterviewStatuses');
            })
        },
    },
    mounted() {
        this.$nextTick(() => {
            chartOptions.chart.events = {
                mounted: function () {
                    self.loading = false;
                }
            }
        });
    }
}
</script>
<style>
#interviewStatuses .apexcharts-legend {
    justify-content: center !important;
    top: 0 !important;
}
</style>
